<template>
  <div>
    <h2>ISIHAC</h2>
    <pre v-if="data">

      <div v-for="link in data.ListBucketResult.Contents" :key="link.Key"><a :href="`https://isihac.msct.dev/${link.Key}`">{{ link.Key }}</a></div>
      
     </pre>
    <p v-else-if="error">Error: {{ error.message }}</p>
    <p v-else>Loading…</p>
  </div>
</template>

<script>
import { XMLParser } from "fast-xml-parser";

export default {
  name: "ISIHACView",

  data() {
    return {
      data: null,
      error: null,
    };
  },

  async mounted() {
    try {
      const response = await fetch(
        "https://isihac.lon1.digitaloceanspaces.com"
      );
      const xmlText = await response.text();

      const parser = new XMLParser();
      this.data = parser.parse(xmlText);
    } catch (err) {
      console.error("Failed to fetch XML:", err);
      this.error = err;
    }
  },
};
</script>
